import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import { noopVoid } from 'reactApp/utils/helpers';

export const renderFamilyFolderModal = (data, onClose = noopVoid) =>
    openPopupHelper({ popupName: popupNames.CREATE_FAMILY_FOLDER, data, onClose });
